import AddNewDocumentDialog from './AddNewDocumentDialog.view';

export default AddNewDocumentDialog;
